<div id="{{ id }}" class="modal {{ cssClass }} {{ showCssClass }}" [attr.data-backdrop]="backdrop" tabindex="-1"
	role="dialog">
	<div class="modal-dialog {{ cssClassModalDialog }} {{ cssClassModalSize }}" role="document">
		<div class="modal-content">
			<ng-content></ng-content>
		</div>
	</div>
</div>